export const defaultTextAlign = 'left';
